/**
 * Методы получения данных с backend
 */
import axios from "axios";
import router from "../router";
import store from "../store";

const ApiUri = "/api";
let RequestApi = {};

/**
 * Запрос к backend
 * @params
 *        url - route на backend
 *        method - метод запроса (GET,POST)
 *        responseType - тип ответа сервера, по умолчанию json
 *        data - параметры фильтрации данных
 * @return {Promise}
 */
RequestApi.request = params => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${ApiUri}${params.url}`,
      method: params.method,
      dataType: "json",
      responseType: params.responseType || "json",
      data: params.data,
      params: params.method === "GET" ? params.data : "",
      headers: params.headers
    })
      .then(response => {
        // console.log(response.data);

        resolve(response.data);
      })
      .catch(error => {
        // если получаем ошибку что неавторизован
        // перенаправит на login
        if (
          router.currentRoute.name !== "login" &&
          error.response &&
          error.response.status === 401
        ) {
          router.push({ name: "login" });
          return;
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.validationErrors
        ) {
          reject(
            error.response.data.validationErrors
              .map(item => (item.msg ? item.msg : Object.values(item)))
              .join(", ")
          );
        } else {
          // открываем сообщение
          store.dispatch("popupInfoOpen", {
            type: "error",
            text: "Некорректный ответ сервера"
          });

          reject("Некорректный ответ сервера");
        }
      });
  });
};

import * as adv from "./requests/advertising";
import * as user from "./requests/user";
import * as hotspot from "./requests/hotspot";
import * as theme from "./requests/theme";
import * as hotspotTheme from "./requests/hotspotTheme";
import * as files from "./requests/files";
import * as wifi from "./requests/wifi";
import * as statistics from "./requests/statisticsGeneral";
import * as statisticsVisits from "./requests/statisticsVisits";
import * as statisticsGone from "./requests/statisticsGone";
import * as news from "./requests/news";
import * as detailing from "./requests/detailing";
import * as templatesStatistics from "./requests/templatesStatistics";
import * as sms from "./requests/sms";
import * as poll from "./requests/poll";
import * as tariff from "./requests/tariff";

Object.assign(
  RequestApi,
  adv,
  user,
  hotspot,
  theme,
  hotspotTheme,
  files,
  wifi,
  statistics,
  statisticsVisits,
  statisticsGone,
  news,
  detailing,
  templatesStatistics,
  sms,
  poll,
  tariff
);

export default RequestApi;
